module.exports = __webpack_public_path__ + "fonts/raleway-v19-latin-ext_latin_cyrillic-ext_cyrillic-regular.f8db8d5a.woff2";